/**
 * Pushes submit_lead_form to dataLayer for GTM.
 * Use in GTM: Custom Event trigger "submit_lead_form", then fire Google Ads conversion tag.
 */
export const pushLeadFormConversion = () => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "submit_lead_form",
    value: 1.0,
    currency: "INR",
  });
};
